const DISCOUNT_TAG_SEGMENT_COUNT = 2;

const extractDiscountPercentage = (discountTag) => {
  const segments = discountTag.split(':');
  return segments.length === DISCOUNT_TAG_SEGMENT_COUNT ? parseFloat(segments[1]) : 0;
};

/**
 * The checkout discount messaging extension recomputes this value and overwrites a stamp it disagrees with.
 *
 * @param {number|string} originalPrice - Pre-discount price in cents.
 * @param {string} discountTag - Product tag in the form `staff_discount:25`.
 * @returns {object} `{ _discount_amount }`, or an empty object when no amount applies.
 */
export const getDiscountAmountProperty = (originalPrice, discountTag) => {
  if (!discountTag) {
    return {};
  }

  const originalPriceInCents = Number(originalPrice);
  const discountPercentage = extractDiscountPercentage(discountTag);

  if (!Number.isFinite(originalPriceInCents) || !Number.isFinite(discountPercentage) || discountPercentage <= 0) {
    return {};
  }

  const discountAmountInCents = Math.round((originalPriceInCents * discountPercentage) / 100);

  return discountAmountInCents > 0 ? { _discount_amount: discountAmountInCents } : {};
};
